<template>
  <a-radio-group
    v-bind="{ ...$props, ...props }"
    :value="props.modelValue"
    :placeholder="placeholder"
    :onChange="dataChange"
    :style="`width:${props.width};`"
    :options="props.options"
    v-if="!props.disabled"
  ></a-radio-group>
  <span class="comValue" v-else>{{ comValue }}</span>
</template>

<script setup>
  import { defineProps, defineEmits, computed } from 'vue'
  const emit = defineEmits()

  const props = defineProps({
    modelValue: {
      required: true, //是否必传
    },
    label: {
      type: String, // 参数类型
      required: true, //是否必传
    },
    value: {
      required: true, //是否必传
    },
    placeholder: {
      type: String, // 参数类型
    },
    'allow-clear': {
      default: false,
    },
    options: {
      type: Array,
      required: true,
    },
    'option-type': {
      default: 'button',
    },
    width: {
      // default: '130px',
    },
    onChange: {
      type: Function,
    },
    disabled: {
      type: Boolean,
      default: false,
    }
  })
  const comValue = computed(() => {
    return props.options?.find((item) => item.value == props.modelValue)?.label || ''
  })
  const placeholder = props?.placeholder
    ? props?.label?.placeholder
    : `请选择${props?.label}`

  function dataChange(data) {
    props.onChange && props.onChange(data)

    emit('update:modelValue', data.target.value)
  }
</script>

<style lang="less" scoped></style>
